var render, staticRenderFns
import script from "./button-item.vue?vue&type=script&lang=js"
export * from "./button-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f265b82",
  null
  
)

export default component.exports